import React from "react";
import { LabelText, TitleText } from "../../ui/Text";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { GetHook } from "../../api/api";
import { get } from "../../utils/get";
import { SCORECARD_URL, PERSPECTIVE_URL } from "../../api/urls";
import { MeasuresContent } from "./MeasuresContent";

interface IProps {
  scorecard_id?: string;
}

export const UpdateMeasures = ({ scorecard_id }: IProps) => {
  const params = useParams();
  const scorecardId = get(params, "scorecard_id") || scorecard_id;

  let { data: allRawPerspectives } = GetHook(`${PERSPECTIVE_URL}`);

  let { data: perspectives } = GetHook(
    scorecardId ? `${SCORECARD_URL}/${scorecardId}/perspective` : "null"
  );

  const non360Perspectives = perspectives.filter((perspective) => {
    const check360 = allRawPerspectives.filter(
      (rawPerspective) =>
        get(rawPerspective, "id") === get(perspective, "perspective_id")
    );
    if (!!!get(check360, "[0].is_360")) {
      return perspective;
    } else {
      return null;
    }
  });

  return (
    <UpdateMeasuresContainer>
      <UpdateMeasuresHeader>
        <LabelText>Measure name</LabelText>
        <LabelText>Score</LabelText>
        <LabelText>Period</LabelText>
        <LabelText>Target</LabelText>
        <LabelText>Actual</LabelText>
      </UpdateMeasuresHeader>
      {non360Perspectives.length > 0 &&
        non360Perspectives.map((perspetive) => (
          <PerspectiveMeasures>
            <TitleText>{get(perspetive, "perspective_name")}</TitleText>
            <MeasuresContent
              perspectiveId={get(perspetive, "perspective_id")}
              scorecard_id={scorecard_id}
            />
          </PerspectiveMeasures>
        ))}
    </UpdateMeasuresContainer>
  );
};

const UpdateMeasuresContainer = styled.div`
  display: grid;
  grid-template-rows: 3em auto;
  padding-bottom: 10em;
`;

const UpdateMeasuresHeader = styled.div`
  display: grid;
  margin: 1em 0;
  grid-template-columns: 0.22fr 0.08fr 0.16fr 0.18fr 0.21fr 0.135fr;
  grid-column-gap: 1em;
`;

const PerspectiveMeasures = styled.div`
  display: grid;
  grid-template-rows: 2em auto;
  grid-row-gap: 0.5em;
  margin-top: 1em;
  ${TitleText} {
    font-size: 12px;
  }
`;